import { Button, Input, Modal, ModalDialog, Option, Radio, RadioGroup, Select } from '@mui/joy';
import { Avatar, InputBase, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReactComponent as PaymentCash } from "../../../../../svg/paymentcash.svg";
import { ReactComponent as PaymentCard } from "../../../../../svg/paymentcredit.svg";
import { ReactComponent as PaymentWithdrawal } from "../../../../../svg/paymentwithdrawal.svg";
import { ReactComponent as PaymentLocal } from "../../../../../svg/paymentlocal.svg";
import { ReactComponent as CardHole } from "../../../../../svg/cardhole.svg";
import { ReactComponent as Creditcard } from "../../../../../svg/creditcardsvg.svg";
import styles from "../money.module.css";
import { getFetch, postFetch, postFetchFormData } from '../../../../../fetch/fetch';
import { processTerminal, processTerminalWithData } from '../functions/talktoterminal';
import { ReactComponent as PaymentSuccess } from "../../../../../svg/paymentcheck.svg";
import { ReactComponent as PaymentFail } from "../../../../../svg/paymentfail.svg";
import ImageUploadModal2 from '../../etc/imageuploadmodal2';
import { PhotoOutlined } from '@mui/icons-material';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import koLocale from 'date-fns/locale/ko';
import { DateRangePicker, DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import Box from '@mui/material/Box';
import { get } from 'lodash';
import { DataGridPremium, GridFilterModel } from '@mui/x-data-grid-premium';
import { ECDH } from 'crypto';
import { dateToDateString } from '../../etc/etcfunctions';
import { tr } from 'date-fns/locale';

const PayModal = ({
    selectedUnpaidOrderItem,
    open,
    handleClose,
    selectedStudent,
    setUpdate,
    notify,
    isNewPayLink,
    selectedBillId
}: any) => {

    const [mode, setMode] = useState<string>("main");
    const [editedTotalPrice, setEditedTotalPrice] = useState<number>(0);
    const [modalMessage, setModalMessage] = useState<string>("");
    const [paymentStatus, setPaymentStatus] = useState<string>("");

    const [uploadFile, setUploadFile] = useState<any>(null);
    const [uploadFileName, setUploadFileName] = useState<any>(null);

    const [cancelLoading, setCancelLoading] = useState<boolean>(false);

    const [imageUploadModalOpen, setImageUploadModalOpen] = useState<boolean>(false);

    const [forcedPaymentMemo, setForcedPaymentMemo] = useState<string>("");

    const [submitLoading, setSubmitLoading] = useState<boolean>(false);

    const [withdrawalData, setWithdrawalData] = useState<any>(null);
    const [accountInfo, setAccountInfo] = useState<any>(null);
    const [selectedAccountId, setSelectedAccountId] = useState<number>(0);

    const [terminalInfos, setTerminalInfos] = useState<any>(null);
    const [approvalData, setApprovalData] = useState<any>(null);
    const [selectedTerminalId, setSelectedTerminalId] = useState<number>(0);

    const [value, setValue] = useState<DateRange<Date>>([null, null]);

    const [rows1, setRows1] = useState<any>([]);
    const [rows2, setRows2] = useState<any>([]);
    const [selectedRow1, setSelectedRow1] = useState<any>(null);
    const [selectedRow2, setSelectedRow2] = useState<any>(null);
    const [columns1, setColumns1] = useState<any>([
        { field : "transDate", headerName : "시간", width : 200},
        { field : "transRemark", headerName : "이름", width : 150},
        { field : "deposit", headerName : "입금액", width : 200},
    ]);
    const [columns2, setColumns2] = useState<any>([
        { field : "approvalDate", headerName : "시간", width : 200},
        { field : "approvalNum", headerName : "승인번호", width : 150},
        { field : "amount", headerName : "승인금액", width : 200},
    ]);
    const [searchName, setSearchName] = useState<string>("");
    const [searchApprovalNum, setSearchApprovalNum] = useState<string>("");
    const [terminalLoading, setTerminalLoading] = useState<boolean>(false);

    const [filterModel1, setFilterModel1] = useState<GridFilterModel>({
        items: [
            { id: 2, field: 'transRemark', operator: 'contains', value: "" },
        ],
    });
    const [filterModel2, setFilterModel2] = useState<GridFilterModel>({
        items: [
            { id: 2, field: 'approvalNum', operator: 'contains', value: "" },
        ],
    });

    const handleCloseImageUploadModal = () => {
        setImageUploadModalOpen(false);
    }


    useEffect(() => {

        console.log(selectedUnpaidOrderItem);

        if (open) {
            setMode("main");

            if (selectedUnpaidOrderItem && selectedUnpaidOrderItem && selectedUnpaidOrderItem.separateValues && selectedUnpaidOrderItem.separateValues.length > 0) {
                setEditedTotalPrice(selectedUnpaidOrderItem.separateValues[0]);
            } else {
                setEditedTotalPrice(0);
            }



        } else {

            setUploadFile(null);
            setUploadFileName(null);
            setForcedPaymentMemo("");
            setSubmitLoading(false);
            setEditedTotalPrice(0);

        }


    }, [open]);

    const handleEditedTotalPrice = (value: number) => {
        setEditedTotalPrice(value);
    }

    const submitForcedPayment = async (type: string) => {

        try {

            if (!selectedUnpaidOrderItem || !forcedPaymentMemo || !uploadFile) {
                return;
            }

            setSubmitLoading(true);

            const formData = new FormData();

            formData.append("file", uploadFile);

            const body = {
                orderItemId: selectedUnpaidOrderItem.id,
                price: editedTotalPrice ? editedTotalPrice : selectedUnpaidOrderItem.price,
                memo: forcedPaymentMemo,
                type,
                isNewPayLink: isNewPayLink ? true : false,
                selectedBillId: selectedBillId ? selectedBillId : null,
            }

            console.log("body", body);

            formData.append("data", JSON.stringify(body));

            const result: any = await postFetchFormData("/dashboard/payments/managepayment/submitforcedpayment", formData);

            setSubmitLoading(false);

            if (result.message === "success") {
                setModalMessage("수동 결제가 정상적으로 처리되었습니다.");
                setPaymentStatus("success");
                setMode("text");
                setUpdate(Math.random());
            } else if (result.message === "alreadyCanceled") {
                setModalMessage("취소된 결제 링크입니다.\n결제링크를 다시 보내주세요.");
                setPaymentStatus("fail");
                setMode("text");
            }

        } catch (e) {
            console.log(e);
        }
    }

    const getWithdrawalData = async () => {

        try{

            setWithdrawalData(null);
            setAccountInfo(null);

            const result : any = await postFetch("/dashboard/payments/managepayment/getwithdrawaldata", {
                value,
                accountId : selectedAccountId
            });

            if(result.message === "success"){
                setWithdrawalData(result.withdrawalData);
                setAccountInfo(result.accountInfo);
            }

        }catch(e){
            console.log(e);
        }

    }

    useEffect(() => {

        if(!withdrawalData){
            return;
        }

        const newRows : any = [];

        withdrawalData.forEach((each : any) => {

            const oneRow : any = {};

            oneRow.id = each.id;
            
            const transDate = new Date(each.transDate);

            oneRow.transDate = dateToDateString(transDate, true);
            oneRow.transRemark = each.transRemark;
            oneRow.deposit = each.deposit ? each.deposit.toLocaleString() + "원" : "0원";
            oneRow.depositRaw = each.deposit ? each.deposit : 0;
            oneRow.bankAccountNum = each.bankAccountNum;

            oneRow.transRefKey = `${each.bankAccountNum}_${each.transRefKey}`;
            oneRow.data = each;

            newRows.push(oneRow);

        })

        setRows1([...newRows]);

    }, [withdrawalData]);

    useEffect(() => {

        if(!open){

            setWithdrawalData(null);
            setAccountInfo(null);
            setSelectedAccountId(0);
            setValue([null, null]);
            setRows1([]);

            setTerminalInfos(null);
            setApprovalData(null);
            setSelectedTerminalId(0);

            return;

        }

    }, [open]);

    useEffect(() => {

        if(!open){
            return;
        }

        getWithdrawalData();

    }, [value, open, selectedAccountId]);

    useEffect(() => {

        if(!open){
            return;
        }

        getTerminalData();

    }, [value, open, selectedTerminalId]);

    useEffect(() => {

        if(!approvalData){
            return;
        }

        const newRows : any = [];

        console.log("approvalData", approvalData);

        approvalData.forEach((each : any, index : number) => {

            const oneRow : any = {};

            oneRow.id = index;
            oneRow.approvalDate = `${each.transdate} ${each.transtime}`;
            oneRow.approvalNum = each.authority;
            oneRow.amount = each.amount ? each.amount.toLocaleString() + "원" : "0원";

            oneRow.amountRaw = each.amount ? each.amount : 0;
            oneRow.tid = each.siteid;

            oneRow.key = each.siteid + "_" + each.authority;

            oneRow.data = each;

            newRows.push(oneRow);

        });

        setRows2([...newRows]);


    }, [approvalData]);

    const getTerminalData = async () => {

        try{

            setTerminalLoading(true);
            setApprovalData(null);
            setRows2([]);

            const result : any = await postFetch("/dashboard/payments/managepayment/getterminaldata", {
                value,
                terminalId : selectedTerminalId
            });

            if(result.message === "success"){
                setTerminalInfos(result.terminalInfos);
                setApprovalData(result.approvalData);
            }

            setTerminalLoading(false);

        }catch(e){
            console.log(e);
        }

    }

    const nameChange = (e: any) => {

        setSearchName(e.target.value);

        const newFilterModel = {...filterModel1};

        newFilterModel.items.forEach((item) => {

            if(item.id === 2){
                item.value = e.target.value;
            }

        });

        setFilterModel1({...newFilterModel});

    }

    const approvalNumChange = (e: any) => {

        setSearchApprovalNum(e.target.value);

        const newFilterModel = {...filterModel2};

        newFilterModel.items.forEach((item) => {
            
            if(item.id === 2){
                item.value = e.target.value;
            }

        });

        setFilterModel2({...newFilterModel});
        
    }

    const submitWithdrawalMatching = async () => {

        try{

            if (!selectedUnpaidOrderItem || !selectedRow1) {
                return;
            }

            const data = {
                orderItemId : selectedUnpaidOrderItem.id,
                price : selectedRow1.depositRaw,
                transRefKey : selectedRow1.transRefKey,
                data : selectedRow1.data,
                type : "withdrawal",
                isNewPayLink: isNewPayLink ? true : false,
                selectedBillId: selectedBillId ? selectedBillId : null,
            }

            console.log("data", data);

            setSubmitLoading(true);

            const result  : any = await postFetch("/dashboard/payments/managepayment/submitwithdrawalmatching", data);

            setSubmitLoading(false);

            if(result.message === "success"){
                setModalMessage("계좌이체 결제가 정상적으로 처리되었습니다.");
                setPaymentStatus("success");
                setMode("text");
                setUpdate(Math.random());
            }else if(result.message === "alreadyCanceled"){
                setModalMessage("취소된 결제 링크입니다.\n결제링크를 다시 보내주세요.");
                setPaymentStatus("fail");
                setMode("text");
            }else{
                setModalMessage("계좌이체 결제 처리에 실패했습니다.\n중복 삽입 가능성이 높습니다.");
                setPaymentStatus("fail");
                setMode("text");
            }

        }catch(e){
            console.log(e);
        }

    }

    const submitTerminalMatching = async () => {

        try{

            if (!selectedUnpaidOrderItem || !selectedRow2) {
                return;
            }

            const data = {
                orderItemId : selectedUnpaidOrderItem.id,
                price : selectedRow2.amountRaw,
                terminalKey : selectedRow2.key,
                data : selectedRow2.data,
                type : "terminal",
                isNewPayLink: isNewPayLink ? true : false,
                selectedBillId: selectedBillId ? selectedBillId : null,
            }

            console.log("data", data);

            setSubmitLoading(true);

            const result  : any = await postFetch("/dashboard/payments/managepayment/submitterminalmatching", data);

            setSubmitLoading(false);

            if(result.message === "success"){
                setModalMessage("단말기 결제가 정상적으로 처리되었습니다.");
                setPaymentStatus("success");
                setMode("text");
                setUpdate(Math.random());
            }else if(result.message === "alreadyCanceled"){
                setModalMessage("취소된 결제 링크입니다.\n결제링크를 다시 보내주세요.");
                setPaymentStatus("fail");
                setMode("text");
            }else{
                setModalMessage("단말기 결제 처리에 실패했습니다.\n중복 삽입 가능성이 높습니다.");
                setPaymentStatus("fail");
                setMode("text");
            }

        }catch(e){
            console.log(e);
        }

    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            sx={{
                backdropFilter: "blur(0px)",
            }}
        >
            <ModalDialog sx={{
                borderRadius: "30px"
            }}>
                <div style={{
                    width: mode === "withdrawal" || mode === "terminal" ? "900px" : "650px",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                    height: mode === "withdrawal" || mode === "terminal" ? "950px" : "522px",
                    fontFamily: "Apple_R",
                }}>
                    {
                        mode === "main"
                            ?
                            <div>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "24px",
                                }}>
                                    <Avatar sx={{ bgcolor: "#b0dbf1" }}><img src="img/user-solid.svg" alt="user" className="avatarImg" /></Avatar>
                                    <span style={{
                                        color: "#575757",
                                        fontFamily: "Apple_SB",
                                        fontSize: "18px",
                                        marginLeft: "12px",
                                    }}>
                                        {
                                            selectedStudent && selectedStudent.name
                                        } 학생
                                    </span>
                                </div>
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}>
                                    <div>
                                        <div style={{
                                            marginBottom: "6px"
                                        }}>
                                            총 결제금액 {selectedUnpaidOrderItem && selectedUnpaidOrderItem.price.toLocaleString()}원 중
                                        </div>
                                        <div>
                                            <span style={{
                                                fontFamily: "Apple_SB",
                                                fontSize: "24px",
                                            }}>
                                                {editedTotalPrice ? editedTotalPrice.toLocaleString() : selectedUnpaidOrderItem && selectedUnpaidOrderItem.price.toLocaleString()} 원을 결제할게요
                                            </span>
                                        </div>
                                    </div>
                                    {
                                        selectedUnpaidOrderItem && selectedUnpaidOrderItem.separateValues && selectedUnpaidOrderItem.separateValues.length > 1
                                            ?
                                            <div>
                                                <Button variant="soft" color="primary" size="lg"
                                                    onClick={() => {
                                                        setMode("divide");
                                                    }}
                                                >
                                                    분할 결제 금액 선택
                                                </Button>
                                            </div>
                                            :
                                            ""
                                    }
                                </div>
                                <div style={{
                                    marginTop: "20px",
                                    marginBottom: "20px",
                                    borderTop: "1px solid #8b8b8b",
                                }} />
                                <div>
                                    <div style={{
                                        fontFamily: "Apple_SB",
                                        marginBottom: "14px"
                                    }}>
                                        결제 방법
                                    </div>
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(2, 1fr)",
                                            gap: "10px",
                                        }}
                                    >
                                        {["단말기", "현금", "계좌이체", "수동결제"].map((item, index) => (
                                            <div key={index} style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                height: "135px",
                                                borderRadius: "12px",
                                                backgroundColor: "#f2f3f4",
                                                cursor: "pointer",
                                                flexDirection: "column",
                                            }}
                                                onClick={() => {
                                                    switch (index) {
                                                        case 0:
                                                            setMode("terminal");
                                                            break;
                                                        case 1:
                                                            setMode("cash");
                                                            break;
                                                        case 2:
                                                            setMode("withdrawal");
                                                            break;
                                                        case 3:
                                                            setMode("forced");
                                                            break;
                                                        default:
                                                            break;
                                                    }
                                                }}
                                            >
                                                <div>
                                                    {
                                                        index === 0 ? <PaymentCard /> :
                                                            index === 1 ? <PaymentCash /> :
                                                                index === 2 ? <PaymentWithdrawal /> :
                                                                    <PaymentLocal />
                                                    }
                                                </div>
                                                <div>
                                                    {item}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            :
                            ""
                    }
                    {
                        mode === "divide"
                            ?
                            <div style={{
                                width: "100%",
                                height: "100%",
                                position: "relative"
                            }}>
                                <div style={{
                                    fontSize: "24px",
                                    fontFamily: "Apple_SB",
                                    marginBottom: "32px"
                                }}>
                                    분할 결제 금액 설정
                                </div>
                                <div>
                                    <RadioGroup
                                        value={editedTotalPrice}
                                        onChange={(event) => {
                                            handleEditedTotalPrice(Number(event.target.value));
                                        }}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "6px",
                                        }}
                                    >
                                        {(selectedUnpaidOrderItem?.separateValues ?? []).map((item: any, index: number) => (
                                            <Radio
                                                key={index}
                                                value={item}
                                                label={`${item.toLocaleString()} 원`}
                                                sx={{
                                                    fontSize: "20px",
                                                    fontFamily: "Apple_R",
                                                }}
                                            />
                                        ))}
                                    </RadioGroup>
                                </div>
                                <div style={{
                                    position: "absolute",
                                    bottom: "0px",
                                    right: "0px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                }}>
                                    <Button variant="solid" color="primary" size="lg"
                                        sx={{
                                            marginLeft: "10px",
                                            width: "180px"
                                        }}
                                        onClick={() => {
                                            setMode("main");
                                        }}
                                    >
                                        확인
                                    </Button>
                                </div>
                            </div>
                            :
                            ""
                    }
                    {
                        mode === "card"
                            ?
                            <div style={{
                                width: "100%",
                                height: "100%",
                                position: "relative"
                            }}>
                                <div style={{
                                    fontSize: "20px"
                                }}>
                                    결제 금액
                                </div>
                                <div>
                                    <span style={{
                                        fontFamily: "Apple_SB",
                                        fontSize: "40px",
                                        marginTop: "12px"
                                    }}>
                                        {editedTotalPrice ? editedTotalPrice.toLocaleString() : selectedUnpaidOrderItem?.price.toLocaleString()}원
                                    </span>
                                </div>

                                <div style={{
                                    fontSize: "20px",
                                    marginTop: "20px",
                                    marginBottom: "10px"
                                }}>
                                    할부
                                </div>


                                <div style={{
                                    position: "absolute",
                                    bottom: "0px",
                                    right: "0px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                }}>
                                    <Button variant="solid" color="neutral" size="lg"
                                        onClick={() => {
                                            setMode("main");
                                        }}
                                    >
                                        취소
                                    </Button>
                                    <Button variant="solid" color="primary" size="lg"
                                        sx={{
                                            marginLeft: "10px",
                                            width: "180px"
                                        }}
                                        onClick={() => {

                                        }}
                                    >
                                        결제하기
                                    </Button>
                                </div>

                            </div>
                            :
                            ""
                    }
                    {
                        mode === "cardprocess"
                            ?
                            <div style={{
                                width: "100%",
                                height: "100%",
                                position: "relative",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                            }}>
                                <div style={{
                                    zIndex: 5
                                }}>
                                    <CardHole />
                                </div>
                                <div className={styles.creditCardAnimation}>
                                    <Creditcard />
                                </div>
                                <div style={{
                                    marginTop: "25px",
                                    color: "#656565",
                                    fontSize: "26px",
                                    fontFamily: "Apple_R",
                                }}>
                                    카드를 넣어주세요.
                                </div>
                                <div style={{
                                    marginTop: "12px",
                                    color: "#656565",
                                    fontSize: "26px",
                                    fontFamily: "Apple_R",
                                }}>
                                    삼성페이도 태깅해주세요.
                                </div>

                                <div style={{
                                    position: "absolute",
                                    bottom: "0px",
                                    right: "0px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                }}>
                                    <Button variant="solid" color="neutral" size="lg"
                                        onClick={() => {
                                        }}
                                        loading={cancelLoading}
                                    >
                                        취소
                                    </Button>
                                </div>
                            </div>
                            :
                            ""
                    }
                    {
                        mode === "text"
                            ?
                            <div style={{
                                width: "100%",
                                height: "100%",
                                position: "relative",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                            }}>
                                {
                                    paymentStatus === "success"
                                        ?
                                        <div>
                                            <PaymentSuccess
                                            />
                                        </div>
                                        :
                                        <div>
                                            <PaymentFail />
                                        </div>
                                }
                                <div style={{
                                    marginTop: "25px",
                                    color: "black",
                                    fontSize: "32px",
                                    fontFamily: "Apple_R",
                                    whiteSpace: "pre-line",
                                    textAlign: "center",
                                }}>
                                    {modalMessage}
                                </div>

                                <div style={{
                                    position: "absolute",
                                    bottom: "0px",
                                    right: "0px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                }}>
                                    <Button variant="solid" color="neutral" size="lg"
                                        onClick={() => {
                                            handleClose();
                                        }}
                                    >
                                        닫기
                                    </Button>
                                </div>
                            </div>
                            :
                            ""
                    }
                    {
                        (mode === "forced" || mode === "cash")
                            ?
                            <div style={{
                                width: "100%",
                                height: "100%",
                                position: "relative"
                            }}>
                                <div style={{
                                    fontSize: "24px",
                                    fontFamily: "Apple_SB",
                                    marginBottom: "32px"
                                }}>
                                    {mode === "forced" ? "수동 결제 처리" : "현금 결제 처리"}
                                </div>
                                <div>
                                    <span style={{
                                        fontFamily: "Apple_SB",
                                        fontSize: "40px",
                                        marginTop: "12px"
                                    }}>
                                        {editedTotalPrice ? editedTotalPrice.toLocaleString() : selectedUnpaidOrderItem?.price.toLocaleString()}원
                                    </span>
                                </div>

                                <div>
                                    <div style={{
                                        fontSize: "20px",
                                        marginTop: "20px",
                                        marginBottom: "10px",
                                        fontFamily: "Apple_SB",
                                    }}>
                                        {mode === "forced" ? "승인 완료 인증 사진 업로드" : "현금 결제 인증 사진 업로드"}
                                    </div>
                                    <div className={styles.imageUploadDiv} style={{
                                        cursor: "pointer",
                                    }}
                                        onClick={() => {
                                            setImageUploadModalOpen(true);
                                        }}
                                    >
                                        <div style={{
                                            marginRight: "0.8rem"
                                        }}>
                                            <PhotoOutlined />
                                        </div>
                                        <div style={{
                                            fontSize: "0.8rem",
                                            marginBottom: "8px"
                                        }}>
                                            {
                                                uploadFileName ? <span>{uploadFileName}</span> : <span style={{
                                                    color: "#6b7583"
                                                }}>승인 완료 캡쳐 내역 업로드 필수</span>
                                            }
                                        </div>
                                    </div>
                                    <div style={{
                                        fontSize: "20px",
                                        marginTop: "20px",
                                        marginBottom: "10px",
                                        fontFamily: "Apple_SB",
                                    }}>
                                        {mode === "forced" ? "수동 결제 내용" : "현금 결제 내용"}
                                    </div>
                                    <div>
                                        <Input
                                            value={forcedPaymentMemo}
                                            onChange={(e) => setForcedPaymentMemo(e.target.value)}
                                            fullWidth
                                            placeholder={mode === "forced" ? "수동 결제에 대한 내용을 입력해주세요." : "현금 결제에 대한 내용을 입력해주세요."}
                                        />
                                    </div>
                                </div>

                                <div style={{
                                    position: "absolute",
                                    bottom: "0px",
                                    right: "0px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                }}>
                                    <Button variant="solid" color="neutral" size="lg"
                                        onClick={() => {
                                            setMode("main");
                                        }}
                                    >
                                        취소
                                    </Button>
                                    <Button variant="solid" color="primary" size="lg"
                                        sx={{
                                            marginLeft: "10px",
                                            width: "180px"
                                        }}
                                        onClick={() => {
                                            submitForcedPayment(mode);
                                        }}
                                        disabled={(!uploadFile || forcedPaymentMemo.trim() === "")}
                                        loading={submitLoading}
                                    >
                                        결제하기
                                    </Button>
                                </div>

                            </div>
                            :
                            ""
                    }
                    {
                        mode === "withdrawal"
                            ?
                            <div style={{
                                width: "100%",
                                height: "100%",
                                position: "relative"
                            }}>
                                <div style={{
                                    fontSize: "24px",
                                    fontFamily: "Apple_SB",
                                    marginBottom: "32px"
                                }}>
                                    계좌이체 처리 ({editedTotalPrice ? editedTotalPrice.toLocaleString() : selectedUnpaidOrderItem?.price.toLocaleString()}원)
                                </div>

                                <div>
                                    <div style={{
                                        fontSize: "20px",
                                        marginTop: "30px",
                                        marginBottom: "12px",
                                        fontFamily: "Apple_SB",
                                    }}>
                                        조회 기간 선택
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <LocalizationProvider locale={koLocale} dateAdapter={AdapterDateFns}>
                                            <DateRangePicker
                                                startText="시작일"
                                                endText="마지막일"
                                                value={value}
                                                onChange={(newValue: any) => {
                                                    console.log(newValue);
                                                    setValue(newValue);

                                                }}
                                                renderInput={(startProps: any, endProps: any) => (
                                                    <React.Fragment>
                                                        <TextField {...startProps} size="small" />
                                                        <Box sx={{ mx: 2 }}> to </Box>
                                                        <TextField {...endProps} size="small" />
                                                    </React.Fragment>
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                    <div style={{
                                        fontSize: "20px",
                                        marginTop: "30px",
                                        marginBottom: "12px",
                                        fontFamily: "Apple_SB",
                                    }}>
                                        조회 계좌 선택
                                    </div>
                                    <div>
                                        <Select
                                            sx={{
                                                width: "440px",
                                                marginRight: "24px",
                                            }}
                                            value={selectedAccountId}
                                            onChange={(e, newValue: any) => {
                                                if (newValue === undefined || newValue === null) {
                                                    return;
                                                }
                                                console.log("newValue", newValue);
                                                setSelectedAccountId(newValue);
                                            }
                                            }>
                                            {
                                                accountInfo && accountInfo.map((each: any, index: number) => {

                                                    return (
                                                        <Option value={each.id} key={index}>{each.name}</Option>
                                                    )

                                                })
                                            }
                                        </Select>
                                    </div>
                                    <div style={{
                                        width : "100%"
                                    }}>
                                        <div style={{
                                            width : "100%",
                                            display : "flex",
                                            justifyContent : "space-between",
                                            alignItems : "center",
                                            marginTop : "20px",
                                            marginBottom : "10px",
                                        }}>
                                            <div />
                                            <div>
                                                <InputBase
                                                    placeholder="이름으로 검색"
                                                    value={searchName}
                                                    onChange={nameChange}
                                                    sx={{
                                                        fontFamily: "Apple_R",
                                                        width: "200px",
                                                        height: "35px",
                                                        borderBottom: "1px solid #c4c4c4",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <DataGridPremium
                                            rows={rows1}
                                            columns={columns1}
                                            filterModel={filterModel1}
                                            onFilterModelChange={(newModel) => setFilterModel1(newModel)}
                                            density='compact'
                                            sx={{
                                                height: '500px',
                                            }}
                                            onRowClick={(params) => {
                                                console.log("params", params);
                                                setSelectedRow1(params.row);
                                            }}
                                        />
                                    </div>
                                </div>

                                <div style={{
                                    position: "absolute",
                                    bottom: "0px",
                                    right: "0px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                }}>
                                    <Button variant="solid" color="neutral" size="lg"
                                        onClick={() => {
                                            setMode("main");
                                        }}
                                    >
                                        취소
                                    </Button>
                                    <Button variant="solid" color="primary" size="lg"
                                        sx={{
                                            marginLeft: "10px",
                                            width: "180px"
                                        }}
                                        onClick={() => {
                                            submitWithdrawalMatching();
                                        }}
                                        disabled={(!selectedRow1 || selectedRow1.depositRaw !== (editedTotalPrice ? editedTotalPrice : selectedUnpaidOrderItem?.price))}
                                        loading={submitLoading}
                                    >
                                        매칭하기
                                    </Button>
                                </div>

                            </div>

                            :
                            ""
                    }
                    {
                        mode === "terminal"
                            ?
                            <div style={{
                                width: "100%",
                                height: "100%",
                                position: "relative"
                            }}>
                                <div style={{
                                    fontSize: "24px",
                                    fontFamily: "Apple_SB",
                                    marginBottom: "32px"
                                }}>
                                    단말기 처리 ({editedTotalPrice ? editedTotalPrice.toLocaleString() : selectedUnpaidOrderItem?.price.toLocaleString()}원)
                                </div>

                                <div>
                                    <div style={{
                                        fontSize: "20px",
                                        marginTop: "30px",
                                        marginBottom: "12px",
                                        fontFamily: "Apple_SB",
                                    }}>
                                        조회 기간 선택
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <LocalizationProvider locale={koLocale} dateAdapter={AdapterDateFns}>
                                            <DateRangePicker
                                                startText="시작일"
                                                endText="마지막일"
                                                value={value}
                                                onChange={(newValue: any) => {
                                                    console.log(newValue);
                                                    setValue(newValue);

                                                }}
                                                renderInput={(startProps: any, endProps: any) => (
                                                    <React.Fragment>
                                                        <TextField {...startProps} size="small" />
                                                        <Box sx={{ mx: 2 }}> to </Box>
                                                        <TextField {...endProps} size="small" />
                                                    </React.Fragment>
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                    <div style={{
                                        fontSize: "20px",
                                        marginTop: "30px",
                                        marginBottom: "12px",
                                        fontFamily: "Apple_SB",
                                    }}>
                                        조회 단말기 선택
                                    </div>
                                    <div>
                                        <Select
                                            sx={{
                                                width: "440px",
                                                marginRight: "24px",
                                            }}
                                            value={selectedTerminalId}
                                            onChange={(e, newValue: any) => {
                                                if (newValue === undefined || newValue === null) {
                                                    return;
                                                }
                                                console.log("newValue", newValue);
                                                setSelectedTerminalId(newValue);
                                            }
                                            }>
                                            {
                                                terminalInfos && terminalInfos.map((each: any, index: number) => {

                                                    return (
                                                        <Option value={each.id} key={index}>{each.name}</Option>
                                                    )

                                                })
                                            }
                                        </Select>
                                    </div>
                                    <div style={{
                                        width : "100%"
                                    }}>
                                        <div style={{
                                            width : "100%",
                                            display : "flex",
                                            justifyContent : "space-between",
                                            alignItems : "center",
                                            marginTop : "20px",
                                            marginBottom : "10px",
                                        }}>
                                            <div />
                                            <div>
                                                <InputBase
                                                    placeholder="승인번호 검색"
                                                    value={searchApprovalNum}
                                                    onChange={approvalNumChange}
                                                    sx={{
                                                        fontFamily: "Apple_R",
                                                        width: "200px",
                                                        height: "35px",
                                                        borderBottom: "1px solid #c4c4c4",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <DataGridPremium
                                            rows={rows2}
                                            columns={columns2}
                                            filterModel={filterModel2}
                                            onFilterModelChange={(newModel) => setFilterModel2(newModel)}
                                            density='compact'
                                            sx={{
                                                height: '500px',
                                            }}
                                            onRowClick={(params) => {
                                                console.log("params", params);
                                                setSelectedRow2(params.row);
                                            }}
                                            loading={terminalLoading}
                                        />
                                    </div>
                                </div>

                                <div style={{
                                    position: "absolute",
                                    bottom: "0px",
                                    right: "0px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                }}>
                                    <Button variant="solid" color="neutral" size="lg"
                                        onClick={() => {
                                            setMode("main");
                                        }}
                                    >
                                        취소
                                    </Button>
                                    <Button variant="solid" color="primary" size="lg"
                                        sx={{
                                            marginLeft: "10px",
                                            width: "180px"
                                        }}
                                        onClick={() => {
                                            submitTerminalMatching();
                                        }}
                                        disabled={(!selectedRow2 || selectedRow2.amountRaw !== (editedTotalPrice ? editedTotalPrice : selectedUnpaidOrderItem?.price))}
                                        loading={submitLoading}
                                    >
                                        매칭하기
                                    </Button>
                                </div>

                            </div>

                            :
                            ""
                    }
                </div>

                <ImageUploadModal2
                    open={imageUploadModalOpen}
                    handleClose={handleCloseImageUploadModal}
                    setUploadFile={setUploadFile}
                    setUploadFileName={setUploadFileName}
                    description="컨텐츠 수동 추가를 위한\n승인 완료 캡쳐 내역을 업로드해주세요."
                />

            </ModalDialog>
        </Modal>
    )

}

export default PayModal;